<template>
  <Application>
    <b-breadcrumb :items="items"></b-breadcrumb>

    <b-row class="mb-3" v-if="!projects.isLoadingProject">
      <b-col>
        <b-card class="bg-dark text-white d-flex">
          <b-row class="d-flex align-items-center">
            <b-col md="4" class="mb-2 mb-lg-0">
              <div>
                <h5 class="font-weight-bold mb-0">
                  {{ project.info.title }}
                </h5>
                <small class="text-light">
                  {{ project.info.description }}
                </small>
              </div>
            </b-col>

            <b-col md="6" lg="4" class="mb-2 mb-lg-0">
              <div class="mb-1">
                <small class="text-muted">Data de criação</small>
              </div>

              <h5>
                {{ createdAt }}
              </h5>
            </b-col>

            <b-col md="6" lg="4" class="mb-2 mb-lg-0 d-flex align-items-center justify-content-end">
              <b-button
                variant="secondary"
                size="sm" class="d-flex align-items-center"
                @click="showProjectSettingsModal"
              >
                <small>
                  <b-icon-gear-fill class="mr-1"/>
                  <strong>Configurar</strong>
                </small>
              </b-button>
            </b-col>
          </b-row>
        </b-card>
      </b-col>
    </b-row>

    <Kanban
      :isLoadingProject="projects.isLoadingProject"
      :isLoadingTasks="projects.isLoadingTasks"
      :boards="(projects.project || {}).boards || []"
      :tasks="(projects.project || {}).tasks || []"
      :info="(projects.project || {}).info || {}"
      @change-broker="fetchTasksByBroker"
      @reload-tasks="reloadTasks"
    />

    <b-modal
      id="edit-project"
      title="Configurar projeto"
      @hidden="reset"
    >
      <b-row>
        <b-col class="mb-2">
          <label>
            Título <span class="text-danger">*</span>
          </label>
          <b-input v-model.trim="form.title" :disabled="isUpdatingProject"/>
        </b-col>
      </b-row>

      <b-row>
        <b-col>
          <label>
            Descrição
          </label>
          <b-input v-model.trim="form.description" maxlength="100" :disabled="isUpdatingProject"/>
        </b-col>
      </b-row>

      <template v-slot:modal-footer>
        <b-button
          variant="outline-secondary"
          size="sm"
          :disabled="false"
          @click="close()"
        >
          Cancelar
        </b-button>
        <CRMButton
          label="Salvar"
          variant="primary"
          size="sm"
          :loading="isUpdatingProject"
          :disabled="isInvalid"
          @click="save()"
        />
      </template>
    </b-modal>
  </Application>
</template>

<script>
import { mapState } from 'vuex';
import Application from '@/components/Application/Application.vue';
import Kanban from '@/components/Projects/Kanban.vue';
import DateParser from '@/parsers/date';
import { UsersService, ProjectsService } from '@/services';
import CRMButton from '@/components/CRMButton/CRMButton.vue';

export default {
  components: {
    Application,
    Kanban,
    CRMButton,
  },

  data() {
    return {
      loading: false,
      isUpdatingProject: false,
      items: [
        { text: 'Dashboard', to: '/' },
        { text: 'Projetos', to: '/projects' },
        { text: '', active: true },
      ],
      form: {
        title: '',
        description: '',
      },
    };
  },

  async created() {
    /* Refactor to vuex */
    UsersService
      .fetchUserProfilesByCompany(this.user.company_id)
      .then((users) => {
        this.$store.commit('settings/SET_USERS', users);
      })
      .catch((err) => {
        console.log(err);
      });

    this.$store.dispatch('projects/fetchProjectInfo', {
      companyId: this.user.company_id,
      slug: this.$route.params.slug,
    });
  },

  methods: {
    fetchTasksByBroker(brokerId) {
      this.$store.dispatch('projects/fetchProjectTasks', {
        projectId: this.project.info.uid,
        userId: this.user.uid,
        brokerId,
      });
    },

    reloadTasks({ brokerId }) {
      this.fetchTasksByBroker(brokerId);
    },

    // updateTasks(tasks) {
    //   this.$store.dispatch('projects/updateProjectTasks', tasks);
    // },

    showProjectSettingsModal() {
      this.form.title = this.project.info.title;
      this.form.description = this.project.info.description;

      this.$bvModal.show('edit-project');
    },

    async save() {
      this.isUpdatingProject = true;

      try {
        await ProjectsService.updateProjectById(this.project.info.uid, this.form);

        this.$store.commit('global/SET_NOTIFICATION', {
          variant: 'success',
          content: 'Projeto configurado com sucesso',
          title: 'Sucesso!',
        }, { root: true });

        await this.$store.dispatch('projects/updateProjectInfo', this.form);

        this.close();
      } catch (err) {
        console.log(err);

        this.$store.commit('global/SET_NOTIFICATION', {
          variant: 'danger',
          content: 'Não foi possível configurar o projeto',
          title: 'Ops! Encontramos um problema',
        }, { root: true });
      }

      this.isUpdatingProject = false;
    },

    close() {
      this.$bvModal.hide('edit-project');
    },

    reset() {
      this.form.title = '';
      this.form.description = '';
      this.isUpdatingProject = false;
    },
  },

  computed: {
    ...mapState(['projects']),

    project() {
      return this.projects.project || {};
    },

    dueDate() {
      const { info } = this.project;

      if (info.due_date) {
        return DateParser.parseFromTimestamp(info.due_date.seconds);
      }

      return null;
    },

    createdAt() {
      const { info } = this.project;

      return DateParser.parseFromTimestamp(info.created_at.seconds);
    },

    isInvalid() {
      return this.form.title === '';
    },
  },
};
</script>
